import { render, staticRenderFns } from "./ManageRoot.vue?vue&type=template&id=ebcc7da0"
import script from "./ManageRoot.vue?vue&type=script&lang=js"
export * from "./ManageRoot.vue?vue&type=script&lang=js"
import style0 from "./ManageRoot.vue?vue&type=style&index=0&id=ebcc7da0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports